import { getWithLocaleFallback } from "../../services/strapiApi";

/**
 * RÃ©cupÃ¨re tous les domaines avec leurs relations et images (produits, services, industries, etc.)
 */
export const fetchDomains = async () => {
  return getWithLocaleFallback(
    "/domains?populate[icon]=true&populate[products][populate]=metaImage&populate[industries][populate]=metaImage&populate[services][populate]=metaImage&populate[rds][populate]=metaImage&populate[companies][populate]=metaImage"
  );
};

/**
 * RÃ©cupÃ¨re un domaine spÃ©cifique par son slug
 */
export const fetchDomainBySlug = async (slug) => {
  const result = await getWithLocaleFallback(
    `/domains?filters[slug][$eq]=${slug}&populate[icon]=true&populate[products][populate]=metaImage&populate[industries][populate]=metaImage&populate[services][populate]=metaImage&populate[rds][populate]=metaImage&populate[companies][populate]=metaImage`
  );

  if (!result.ok) {
    return result;
  }

  const item = Array.isArray(result.data) ? result.data[0] : null;
  if (!item) {
    return {
      ok: false,
      reason: "NOT_FOUND",
      status: result.status,
      data: null,
      error: null,
    };
  }

  return { ...result, data: item };
};
